module.exports = __webpack_public_path__ + "static/img/avatar.c2ba1c58.png";